export enum PaymentMethodEnum {
  CASH = 1,
  BANK = 2,
  LIVE_PAY = 3,
}
